// Generated by ReScript, PLEASE EDIT WITH CARE


function getVehicleDefaultLocation(status) {
  if (status > 3 || status < 1) {
    return /* Start */0;
  } else {
    return /* End */1;
  }
}

export {
  getVehicleDefaultLocation ,
  
}
/* No side effect */
